"use client"

import { useState } from "react"
import SEO from './SEO';
import emailjs from "@emailjs/browser";
import { useNavigate } from "react-router-dom";



const Contact = () => {
  const navigate = useNavigate();
  const schema = [
  {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    "name": "MAMS Hospitals",
    "url": "https://mamshospitals.com",
    "logo": "https://mamshospitals.com/MAMS-Logo.png",
    "description": "MAMS Hospitals - A legacy of healing, compassion, and excellence in healthcare since 1992.",
    "foundingDate": "1996",
    "founder": {
      "@type": "Person",
      "name": "Sri Puvvada Nageswara Rao"
    },
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Bachupally, Hyderabad, Telangana – 500090",
      "addressLocality": "Hyderabad",
      "addressRegion": "Telangana",
      "postalCode": "500090",
      "addressCountry": "IN"
    },
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "contactType": "customer service",
        "telephone": "+91-7399999981",
        "email": "contact@mamshospitals.com",
        "availableLanguage": ["English", "Hindi", "Telugu"]
      }
    ],
    "sameAs": [
      "https://www.facebook.com/MAMSHospitals",
      "https://www.instagram.com/mams_hospitals"
    ]
  },


  {
 "@context": "https://schema.org",
  "@type": "ContactPage",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://mamshospitals.com/contact"
  },
  "description": "Reach out to MAMS Hospitals in Bachupally, Hyderabad for queries, appointments, or emergency assistance. Open 24/7 emergency services, OPD timings, diagnostic hours, and pharmacy services.",
  "publisher": {
    "@type": "Hospital",
    "name": "MAMS Hospitals",
    "url": "https://mamshospitals.com",
    "logo": "https://mamshospitals.com/MAMS-Logo.png",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Bachupally",
      "addressLocality": "Hyderabad",
      "addressRegion": "Telangana",
      "postalCode": "500090",
      "addressCountry": "IN"
    },
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "contactType": "Customer Service",
        "telephone": "+91-7399999981",
        "availableLanguage": ["English", "Hindi", "Telugu"]
      },
      {
        "@type": "ContactPoint",
        "contactType": "Emergency",
        "telephone": "+91-7399999981",
        "availableLanguage": ["English", "Hindi", "Telugu"]
      }
    ],
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"
        ],
        "opens": "09:00",
        "closes": "17:00",
        "description": "OPD Broad Specialties"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"
        ],
        "opens": "10:00",
        "closes": "16:00",
        "description": "OPD Super Specialties"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"
        ],
        "opens": "08:00",
        "closes": "20:00",
        "description": "Laboratory & Diagnostics"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"
        ],
        "opens": "00:00",
        "closes": "23:59",
        "description": "Pharmacy & Emergency Services"
      }
    ],
    "sameAs": [
      "https://www.facebook.com/mamshospitals",
      "https://www.instagram.com/mamshospitals"
    ]
  }
}
];


/* ---------------- FORM STATE ---------------- */
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    gender: "",
    dob: "",
    visitType: "",
      message: "",   // ✅ MUST exist

  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .send(
        "service_mfxrmqm",
        "template_0h1j6o6", // 🔁 replace with real template ID
        {
          first_name: formData.firstName,
          last_name: formData.lastName,
          email: formData.email,
          phone: formData.phone,
          gender: formData.gender,
          dob: formData.dob,
          visit_type: formData.visitType,
              message: formData.message, // ✅ REQUIRED

        },
        "EQIu7gTx1Ns0SiRpq" // 🔁 replace with real public key
      )
      .then(() => {
        alert("Appointment booked successfully!");
        navigate("/");
      })
      .catch(() => {
        alert("Submission failed. Please try again.");
      });
  };

  return (
    <>
      <SEO
        title="Contact MAMS Hospital Hyderabad – Address, Phone & Email"
        description="Get in touch with Mamata Academy of Medical Sciences Hospital, Bachupally Hyderabad. Address, emergency & hospital phone contacts, email info@mams.org.in & mamshyderabad@gmail.com."
        keywords="Hyderabad's Best Multispecialty Hospital, Best Hospital near Bachupally Hyderabad, Best Hospital near Miyapur Hyderabad, Best Hospital near Nizampet, Multispecialty Hospital near KPHB Colony, Emergency Hospital near JNTU Hyderabad, 24-hour Hospital in Bachupally Hyderabad, Emergency Care Hospital in Hyderabad, Best Cardiology Hospital in Hyderabad, Best Neurology Hospital Hyderabad, Orthopaedics Hospital in Bachupally Hyderabad, Best Joint Replacement Hospital Hyderabad, Spine Surgery Specialist Hyderabad, Best ENT Hospital in Hyderabad, Best Gynecology Hospital Hyderabad, Maternity & Child Care Hospital Hyderabad, Best Pediatric Hospital in Bachupally, Neonatal ICU Hospital Hyderabad, General Medicine Specialist Hyderabad, Best General Surgery Hospital Hyderabad, Critical Care Hospital near Miyapur Hyderabad, Best Physiotherapy Hospital Hyderabad, Mamata Academy of Medical Sciences hospital,Mamata Academy of Medical Sciences Hospital address, contact number MAMS Hospital Hyderabad, emergency contact Hyderabad hospital, MAMS Hospital email info@mams.org.in, reach hospital Bachupally"
        schema={schema}
      canonicalUrl="https://mamshospitals.com/contact"
      />

    <div className="flex flex-col min-h-screen">
      {/* Hero Section */}
      <section className="bg-primary/5 py-12 md:py-12">
        <div className="container mx-auto px-4 max-w-6xl">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-3xl md:text-5xl font-bold text-gray-800 mb-6">Contact Us</h1>
            <p className="text-lg text-gray-600">
              We're here to help. Reach out with any questions about our services or to schedule an appointment.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Information */}
      <section className="py-8 md:py-16 px-0 md:px-4">
        <div className="container mx-auto max-w-6xl">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
            <div className="bg-white shadow-sm p-6 rounded-lg border border-gray-200">
              <div className="flex flex-col items-center text-center">
                <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mb-4">
                  <svg className="h-6 w-6 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                  </svg>
                </div>
                <div className="text-lg font-semibold mb-2">Location</div>
                <p className="text-gray-600">Bachupally, Hyderabad, Telangana – 500090</p>
              </div>
            </div>

            <div className="bg-white shadow-sm p-6 rounded-lg border border-gray-200">
              <div className="flex flex-col items-center text-center">
                <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mb-4">
                  <svg className="h-6 w-6 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                    />
                  </svg>
                </div>
                <div className="text-lg font-semibold mb-2">Phone</div>
                <p className="text-gray-600">+91-7399999981</p>
                <p className="text-gray-600 mt-1">Emergency: 24/7 available</p>
              </div>
            </div>

            <div className="bg-white shadow-sm p-6 rounded-lg border border-gray-200">
              <div className="flex flex-col items-center text-center">
                <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mb-4">
                  <svg className="h-6 w-6 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>
                </div>
                <div className="text-lg font-semibold mb-2">Email</div>
                <p className="text-gray-600">Emergency Services</p>
                <p className="text-gray-600 mt-1">We respond within 24 hours</p>
              </div>
            </div>
          </div>






            {/* Contact form*/}

 {/* <div>
              <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6">Send Us a Message</h2>
              <div className="bg-white p-6 rounded-lg border border-gray-200">
                {formSubmitted ? (
                  <div className="text-center py-8">
                    <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                      <svg className="text-green-600 w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <h3 className="text-xl font-semibold mb-2">Message Sent</h3>
                    <p className="text-gray-600 mb-4">Thank you for contacting us. We'll get back to you shortly.</p>
                    <button
                      onClick={() => setFormSubmitted(false)}
                      className="bg-teal-600 text-white px-6 py-3 rounded-full font-medium hover:bg-teal-700 transition-colors"
                    >
                      Send Another Message
                    </button>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit} className="space-y-4">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      <div className="space-y-2">
                        <label htmlFor="name" className="block text-sm font-medium text-gray-700">
                          Name
                        </label>
                        <input
                          id="name"
                          name="name"
                          required
                          placeholder="Your full name"
                          value={formData.name}
                          onChange={handleInputChange}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-teal-600"
                        />
                      </div>
                      <div className="space-y-2">
                        <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                          Email
                        </label>
                        <input
                          id="email"
                          name="email"
                          type="email"
                          required
                          placeholder="Your email address"
                          value={formData.email}
                          onChange={handleInputChange}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-teal-600"
                        />
                      </div>
                    </div>
                    <div className="space-y-2">
                      <label htmlFor="phone" className="block text-sm font-medium text-gray-700">
                        Phone Number
                      </label>
                      <input
                        id="phone"
                        name="phone"
                        placeholder="Your phone number"
                        value={formData.phone}
                        onChange={handleInputChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-teal-600"
                      />
                    </div>
                    <div className="space-y-2">
                      <label htmlFor="subject" className="block text-sm font-medium text-gray-700">
                        Subject
                      </label>
                      <input
                        id="subject"
                        name="subject"
                        required
                        placeholder="What is this regarding?"
                        value={formData.subject}
                        onChange={handleInputChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-teal-600"
                      />
                    </div>
                    <div className="space-y-2">
                      <label htmlFor="message" className="block text-sm font-medium text-gray-700">
                        Message
                      </label>
                      <textarea
                        id="message"
                        name="message"
                        required
                        placeholder="Your message..."
                        rows="4"
                        value={formData.message}
                        onChange={handleInputChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-teal-600 resize-none"
                      />
                    </div>
                    <button
                      type="submit"
                      className="w-full bg-teal-600 text-white px-6 py-3 rounded-full font-medium hover:bg-teal-700 transition-colors"
                    >
                      Send Message
                    </button>
                  </form>
                )}
              </div>
            </div>         */}



<div className="container mx-auto max-w-6xl px-4">

  {/* =======================
      ROW 1: Timings + Form
     ======================= */}
  <div className="flex flex-col md:flex-row gap-8 items-start mb-16">

    {/* Hospital Timings */}
    <div className="flex-1">
      <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6">
        Hospital Timings
      </h2>

      <div className="bg-white p-6 rounded-lg border border-gray-200">
        <div className="space-y-4">

          <div>
            <div className="font-semibold mb-2">OPD Timings</div>
            <div className="space-y-2">
              <div className="flex justify-between">
                <span className="text-gray-600">Broad Specialties</span>
                <span className="font-medium">9:00 AM – 5:00 PM</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Super Specialties</span>
                <span className="font-medium">10:00 AM – 4:00 PM</span>
              </div>
            </div>
          </div>

          <div className="pt-4 border-t">
            <div className="font-semibold mb-2">Emergency Services</div>
            <p className="text-gray-600">
              Available 24/7, all days of the week
            </p>
          </div>

          <div className="pt-4 border-t">
            <div className="font-semibold mb-2">Laboratory & Diagnostics</div>
            <p className="text-gray-600">
              8:00 AM – 8:00 PM (Everyday)
            </p>
          </div>

          <div className="pt-4 border-t">
            <div className="font-semibold mb-2">Pharmacy</div>
            <p className="text-gray-600">
              24 hours service
            </p>
          </div>

        </div>
      </div>
    </div>

            {/* 3️⃣ FORM CONTAINER */}
            <div className="bg-white rounded-2xl shadow-2xl p-6">
                <h3 className="text-xl font-bold mb-6 text-teal-600">
                    Book Appointment
                </h3>

                <form className="space-y-4" onSubmit={handleSubmit}>

                    {/* NAME */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <input
                        type="text"
                        name="firstName"
                        placeholder="First Name*"
                        required
                        onChange={handleChange}
                        className="w-full border rounded-md px-4 py-2"
                    />
                    <input
                        type="text"
                        name="lastName"
                        placeholder="Last Name*"
                        required
                        onChange={handleChange}
                        className="w-full border rounded-md px-4 py-2"
                    />
                    </div>

                    {/* EMAIL + PHONE */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <input
                        type="email"
                        name="email"
                        placeholder="Email Address*"
                        required
                        onChange={handleChange}
                        className="w-full border rounded-md px-4 py-2"
                    />
                    <input
                      type="tel"
                      name="phone"
                      placeholder="Phone Number*"
                      required
                      maxLength={10}
                      pattern="[0-9]{10}"
                      inputMode="numeric"
                      onChange={(e) => {
                        // allow only numbers & limit to 10 digits
                        e.target.value = e.target.value.replace(/\D/g, "").slice(0, 10)
                        handleChange(e)
                      }}
                      className="w-full border rounded-md px-4 py-2"
                    />

                    </div>

                    {/* GENDER + DOB */}
                    
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                        <label htmlFor="gender" className="block text-sm font-medium mb-1">
                            Gender *
                          </label>

                          <select
                            id="gender"
                            name="gender"
                            required
                            onChange={handleChange}
                            className="w-full border rounded-md px-4 py-2"
                          >
                            <option value="">Select Gender*</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                            <option value="Other">Other</option>
                        </select>

                        {/* Appointment Date with label (mobile-safe) */}
                          <div className="flex flex-col">
                            <label
                              htmlFor="appointmentDate"
                              className="block text-sm font-medium text-gray-600 mb-1"
                            >
                              Appointment Date *
                            </label>

                            <input
                              id="appointmentDate"
                              type="date"
                              name="appointmentDate"
                              required
                              min={new Date().toISOString().split("T")[0]}
                              onChange={handleChange}
                              className="w-full border rounded-md px-4 py-2 text-gray-700"
                            />
                          </div>



                        </div>


        {/* ✅ Message Input Box (Full Width) */}
            <textarea
              name="message"
              placeholder="Message / Health concern (optional)"
              rows={4}
              onChange={handleChange}
              className="w-full border rounded-md px-4 py-2 resize-none md:col-span-2"
            ></textarea>
          

        {/* Visit Type */}
        <div>
          <p className="text-sm font-medium mb-2">
            Is this your first visit to MAMS Hospitals?
          </p>
          <div className="flex gap-6 text-sm">
            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="visitType"
                value="New Patient"
                required
                onChange={handleChange}
              />
              Yes, I’m a new patient
            </label>
            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="visitType"
                value="Existing Patient"
                onChange={handleChange}
              />
              No, I’ve been here before
            </label>
          </div>
        </div>

        {/* Submit */}
        <button
          type="submit"
          className="w-full bg-[#096256] text-white py-3 rounded-md font-semibold hover:bg-[#074a42]"
        >
          Book Appointment
        </button>

      </form>
    </div>

  </div>

  {/* =======================
      ROW 2: Find Us (Full Width)
     ======================= */}
  <div className="mb-20">
    <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6">
      Find Us
    </h2>

    <div className="bg-gray-100 h-80 md:h-96 rounded-lg overflow-hidden">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3804.349310566775!2d78.35541607493836!3d17.538548183374637!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb8dbdc11686bb%3A0x5f01e98c379fa086!2sMamata%20Academy%20of%20Medical%20Sciences%20Hospital!5e0!3m2!1sen!2sin!4v1752238955751!5m2!1sen!2sin"
        className="w-full h-full border-0"
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="MAMS Hospital Location"
      />
    </div>

    <p className="text-gray-600 mt-4">
      MAMS Hospitals is conveniently located in Bachupally, Hyderabad,
      with easy access from major roads and public transportation.
    </p>
  </div>

</div>


        </div>
      </section>
    </div>
    </>
  )
}

export default Contact
